import { Listbox } from '@headlessui/react';
import { FaCheckCircle } from 'react-icons/fa';
import { twMerge } from 'tailwind-merge';

import { DropdownOptionProps, DropdownValue } from './types';

function DropdownOption<T extends DropdownValue>({ value, children, disabled, className }: DropdownOptionProps<T>) {
  return (
    <Listbox.Option
      disabled={disabled}
      value={value}
      className={({ active }) =>
        twMerge('rounded-lg px-3 py-2 text-sm hover:bg-neutral-200 focus:bg-neutral-200', active && 'bg-neutral-200', className)
      }
    >
      {({ selected }) => (
        <div className="relative flex items-center">
          <span className={twMerge('truncate', selected ? 'mr-4 font-semibold' : undefined)}>{children}</span>
          {selected ? <FaCheckCircle className="absolute right-0 text-green-600" role="img" aria-label="checkmark icon" /> : null}
        </div>
      )}
    </Listbox.Option>
  );
}

export type { DropdownOptionProps };

export { DropdownOption };
